import axios from 'axios'
var baseURL = 'https://apis.auto-learning.com/v3/';
const $http = axios.create({
    baseURL,
})
 
export function get(config){  
    return $http(config)
} 
export function post(config,datas={}){ 
     
    //config.headers['X-Token'] = getCookie('sessionId');
     
    let newVar = axios.create({
        headers: {'content-type':'application/x-www-form-urlencoded',Accept:'/'},
        baseURL: baseURL,
        data:datas,
        method:'POST',
        timeout:5000
    });
    return newVar(config)
}
 